import i18n from "./index";
import type { TranslationsDocument } from "../api/translations";
import { getTranslations } from "../api/translations";

/** Apply a fetched translations document to the live i18next instance. */
export function applyTranslations(doc: TranslationsDocument): void {
  (["en", "ru"] as const).forEach((lang) => {
    const namespaces = doc[lang] ?? {};
    Object.entries(namespaces).forEach(([ns, dict]) => {
      // addResourceBundle(lang, ns, resources, deep, overwrite)
      i18n.addResourceBundle(lang, ns, dict, true, true);
    });
  });
}

/** Fetch from /api/translations/ and apply. Resolves when i18next is fully
 * populated. Throws on network failure — the caller decides whether to retry
 * or surface a fallback UI. */
export async function bootstrapI18n(): Promise<void> {
  const doc = await getTranslations();
  applyTranslations(doc);
}
